import React, { Component } from 'react';

export default class SetOverdue extends Component {
  state = {
    error: '',
    loading: false,
    success: true,
  };

  onClick = () => {
    const { purchaseId, onPress, onPressComplete } = this.props;
    this.setState({ loading: true, success: false, error: '' });

    onPress(purchaseId)
      .then((res) => {
        this.setState({ success: true, loading: false });
        onPressComplete(purchaseId);
        setTimeout(() => {
          this.setState({ success: false });
        }, 5000);
      })
      .catch((err) => {
        const error =
          err.response &&
          err.response.data &&
          (err.response.data.message ||
            err.response.data.detail ||
            err.response.data.details ||
            err.response.data.status);
        const defaultMessage = 'Something went wrong';
        const composedError = error || defaultMessage;
        const errMsg =
          typeof composedError === 'string'
            ? composedError
            : JSON.stringify(composedError);

        this.setState({ error: errMsg, loading: false });
        setTimeout(() => {
          this.setState({ error: '' });
        }, 15000);
      });
  };

  render() {
    const { error, success, loading } = this.state;
    return (
      <span className="mar-r">
        <button
          className="btn btn-default"
          onClick={this.onClick}
          disabled={loading}
        >
          Set Overdue
        </button>
        {success && (
          <span className="text-success">
            <br />
            {success}
          </span>
        )}
        {error && (
          <span className="text-danger">
            <br />
            {error}
          </span>
        )}
      </span>
    );
  }
}
